"use client";

import type { ReactNode } from "react";
import { PortalDashboardShell } from "@/components/portal/portal-dashboard-shell";
import type { PortalPageKey, PortalPageState } from "@/lib/portal-pages";
import type { PortalRole } from "@/lib/portal-auth-shared";

type PortalChromeUser = {
  email: string;
  fullName?: string;
  placeOfWork?: string;
  workRole?: string;
  role: PortalRole;
};

type PortalChromeProps = {
  /** The authoritative Advanced Agent decision (issue #45); see PortalRenderContext. */
  advancedAgentEnabled?: boolean;
  billingManagementEnabled?: boolean;
  capacityRiskTrackerEnabled?: boolean;
  financialModelPreviewsEnabled?: boolean;
  contentCmsHref?: string;
  currentUser?: PortalChromeUser;
  hasPasskey?: boolean;
  notesFeedEnabled?: boolean;
  publicPreview?: boolean;
  showDeveloperTools?: boolean;
  showDeveloperAdminItems?: boolean;
  pages: PortalPageState[];
  accessiblePageKeys: readonly PortalPageKey[];
  children: ReactNode;
};

export function PortalChrome({
  advancedAgentEnabled,
  billingManagementEnabled,
  capacityRiskTrackerEnabled,
  financialModelPreviewsEnabled,
  contentCmsHref,
  currentUser,
  hasPasskey,
  notesFeedEnabled,
  publicPreview,
  showDeveloperTools,
  showDeveloperAdminItems,
  pages,
  accessiblePageKeys,
  children,
}: PortalChromeProps) {
  return (
    <PortalDashboardShell
      advancedAgentEnabled={advancedAgentEnabled}
      billingManagementEnabled={billingManagementEnabled}
      capacityRiskTrackerEnabled={capacityRiskTrackerEnabled}
      financialModelPreviewsEnabled={financialModelPreviewsEnabled}
      contentCmsHref={contentCmsHref}
      currentUser={currentUser}
      hasPasskey={hasPasskey}
      notesFeedEnabled={notesFeedEnabled}
      publicPreview={publicPreview}
      showDeveloperTools={showDeveloperTools}
      showDeveloperAdminItems={showDeveloperAdminItems}
      pages={pages}
      accessiblePageKeys={accessiblePageKeys}
    >
      {children}
    </PortalDashboardShell>
  );
}
